<template>
  <div v-cloak style="background-color: #F4F4F4;min-height: 100vh">
    <div class="wrap-background van-hairline--top" style="display: flex;justify-content: space-between;align-items:center;padding: 20px 20px">
      <div style="color: #2e2e2e;font-size: 14px">当前点券</div>
      <div style="color: #FD4E02;font-weight: bold;font-size: 16px">
        {{westore.state.user.userInfo.balance}}
      </div>
    </div>
    <div class="wrap-background" style="padding: 20px 20px;margin-top: 5px">
      <div style="color: #2e2e2e;font-size: 14px">充值点券</div>
      <div class="qaun-wrap">
        <div class="quan-row">
          <div :class="{'quan-col':true, 'van-hairline--surround':true, active:current==='200'}" @click="clickItem('200')">
            <div class="present">赠送{{westore.state.user.userInfo.recharge['200'].present}}点券</div>
            <div class="price">
              <span>{{westore.state.user.userInfo.recharge['200'].price}}元</span>
              <span>{{westore.state.user.userInfo.recharge['200'].amount}}点券</span>
            </div>
          </div>
          <div :class="{'quan-col':true, 'van-hairline--surround':true, active:current==='500'}" @click="clickItem('500')">
            <div class="present">赠送{{westore.state.user.userInfo.recharge['500'].present}}点券</div>
            <div class="price">
              <span>{{westore.state.user.userInfo.recharge['500'].price}}元</span>
              <span>{{westore.state.user.userInfo.recharge['500'].amount}}点券</span>
            </div>
          </div>
        </div>
        <div class="quan-row">
          <div :class="{'quan-col':true, 'van-hairline--surround':true, active:current==='800'}" @click="clickItem('800')">
            <div class="present">赠送{{westore.state.user.userInfo.recharge['800'].present}}点券</div>
            <div class="price">
              <span>{{westore.state.user.userInfo.recharge['800'].price}}元</span>
              <span>{{westore.state.user.userInfo.recharge['800'].amount}}点券</span>
            </div>
          </div>
          <div :class="{'quan-col':true, 'van-hairline--surround':true, active:current==='1000'}" @click="clickItem('1000')">
            <div class="present">赠送{{westore.state.user.userInfo.recharge['1000'].present}}点券</div>
            <div class="price">
              <span>{{westore.state.user.userInfo.recharge['1000'].price}}元</span>
              <span>{{westore.state.user.userInfo.recharge['1000'].amount}}点券</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap-background" style="color: #999;padding: 20px 20px;margin-top: 5px">
      <div style="font-size: 14px">温馨提示</div>
      <div style="font-size: 12px;line-height: 20px;margin-top: 8px">1.点券可以在购买分析时使用 2.使用点券购买分析退款时，退回的是点券 3.点券一经售出，不可退换</div>
    </div>
    <div class="wrap-background" style="color: #999;padding: 20px 20px;margin-top: 5px">
      <van-button type="primary" block color="#1aad19" @click="alertMenu">立即充值</van-button>
      <van-action-sheet :round="false" v-model="menu.show">
        <div class="weball-action-wrap" v-if="westore.getters.logined">
          <div v-if="browser.browser().wechat">
            <div @click="onSelect({current:current, way:'wepay'})" class="van-hairline--top weball-action">
              <div>微信支付</div>
            </div>
            <div v-if="westore.state.user.userInfo != null" @click="onAlipay(current)" class="van-hairline--top weball-action">
              <div>支付宝支付</div>
            </div>
          </div>
          <div v-else>
            <div @click="onSelect({current:current, way:'alipay'})" class="van-hairline--top weball-action">
              <div>支付宝支付</div>
            </div>
            <div @click="onWepay(current)" class="van-hairline--top weball-action">
              <div>微信支付</div>
            </div>
          </div>
          <div style="background-color: #f4f4f4;height: 10px"></div>
          <div @click="menu.show = false" class="weball-action">取消</div>
        </div>
      </van-action-sheet>
    </div>
    <anti-lost-dialog ref="antilost"></anti-lost-dialog>
  </div>
</template>

<script>
import AntiLostDialog from "@/views/components/AntiLostDialog";
export default {
  name: 'recharge',
  components:{
    AntiLostDialog
  },
  data(){
    return{
      current:'200',
      menu: {
        show: false,
        actions: []
      },
    }
  },
  methods:{
    clickItem(name){
      this.current = name
    },
    getUserInfo:function(){
      let that = this;
      this.westore.dispatch('getUserInfo').then(user => {
      }).catch((res) => {
        that.westore.commit('setToken', '')
      })
    },
    onWepay:function(recharge_id){
      this.$refs.antilost.show()
      this.menu.show = false;
    },
    onAlipay:function(recharge_id){
      this.$router.push({
        name: this.werouter.alipayrecharge.name,
        query: {
          recharge_id: recharge_id,
          app_id: this.westore.state.app.app_id,
          uid: this.westore.state.user.userInfo.uid,
          guide:true
        }
      })
    },
    buy: function (data) {
      let that = this;
      if(data.way === 'wepay'){
        this.recharge()
      }
      else if(data.way === 'alipay'){
        this.weapi.request({
          url: 'pay/alipay/ticket',
          method: 'get',
          params: {
            app_id: this.westore.state.app.app_id,
            recharge_id: data.current,
            rechargeData:this.westore.state.user.userInfo.recharge[data.current]
          },
        }).then(res => {
          console.log(res)
          if (res.status === 200) {
            const div = document.createElement('div')
            /* 此处form就是后台返回接收到的数据 */
            div.innerHTML = res.data
            document.body.appendChild(div)
            document.forms[0].submit()
          }
          else if(res.status === 202){
            that.$toast(res.data);
          }
          else {

          }
        }).catch(function (error) {
          console.log(error)
          that.$toast('支付错误，请联系客服！');
        }).finally(function (response) {
        })

      }
    },
    onSelect: function (data) {
      this.menu.show = false;
      this.buy(data);
    },
    alertMenu: function () {
      if (this.westore.getters.logined) {
        this.menu.show = true;
      }
      else {
        this.$router.push({
          name: this.werouter.login.name,
          query: {redirect_name:this.werouter.index.name, project_id: this.project.project_id}
        })
      }
    },
    recharge: function () {
      if(this.browser.browser().wechat){
        this.westore.dispatch('payRecharge', {
          app_id: this.westore.state.app.app_id,
          recharge_id:this.current,
          rechargeData:this.westore.state.user.userInfo.recharge[this.current]
        }).then(res => {
          this.$toast("充值成功！");
          this.getUserInfo();
        }).catch((res) => {
          this.$toast(res);
        })
      }
      else{
        this.$refs.antilost.show()
      }

    },
  }
}
</script>
<style scoped>
  .wrap-background{
    background-color: #FFF;
  }
  .qaun-wrap{
    margin-top: 20px;
  }
  .quan-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .quan-row:first-child{
    margin-bottom: 20px;
  }
  .quan-col:first-child{
    margin-right: 20px;
  }
  .quan-col{
    width: calc(50vw - 30px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .quan-col.active{
    background-color: rgba(253, 78, 2, 0.1);
  }
  .active.van-hairline--surround::after{
    border-color: #FD4E02;
  }
  .quan-col .present{
    color: #FD4E02;
    font-size: 12px;
    margin: 15px 0 4px 0;
  }
  .quan-col .price{
    color: #2e2e2e;
    font-size: 12px;
    margin: 4px 0 15px 0;
  }
  .quan-col .price span:first-child{
    margin-right: 5px;
  }
  .weball-action-wrap {
    z-index: 10000;
    background-color: #fff;
  }

  .weball-action {
    padding: 15px 0;
    text-align: center;
    font-size: 14px;
  }

  .weball-action span {
    margin: 0 4px;
    color: #1aad19;
    font-weight: bold;
  }
  .buy-content {
    margin: 15px 0;
    display: flex;;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .buy-content-des {
    font-size: 13px;
    line-height: 20px;
    color: #333;
    margin: 15px;
    text-align: justify;
  }
</style>
